import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateTitle',
})
export class TruncateTitlePipe implements PipeTransform {
  transform(title: string, isCollapsed: boolean, maxLength = 3): string {
    if (!title) return '';

    if (isCollapsed && title.length > maxLength) {
      return title.substring(0, maxLength) + '..';
    }

    return title;
  }
}
